"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var react_query_1 = require("react-query");
var trans_1 = __importDefault(require("@/plugins/trans"));
var material_1 = require("@mui/material");
var react_router_dom_1 = require("react-router-dom");
var UserContext_1 = __importDefault(require("../context/UserContext"));
var VacanciesPage_1 = __importDefault(require("./VacanciesPage"));
var SearchBarContainer_1 = __importDefault(require("../search/SearchBarContainer"));
var Line_1 = __importDefault(require("../components/Line"));
var BookmarkedContext_1 = __importDefault(require("../context/BookmarkedContext"));
var useIsSmallScreen_1 = __importDefault(require("../hooks/useIsSmallScreen"));
var classes = {
    buttonGroup: {
        display: 'flex',
        flexDirection: 'row',
        gap: '16px',
        marginBottom: 2,
        marginLeft: { xs: 2, md: 0 },
    },
    button: {
        color: 'black',
        textTransform: 'none',
        fontWeight: 'bold',
        fontSize: '18px',
    },
    buttonActive: {
        textTransform: 'none',
        fontWeight: 'bold',
        fontSize: '18px',
        backgroundColor: 'white',
        borderRadius: '50px',
        padding: '0.5rem',
        border: '1px solid',
    },
};
var YourVacanciesPageContainer = function () {
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    var vacancyParam = (0, react_router_dom_1.useParams)().vacancyId;
    var userId = (0, react_1.useContext)(UserContext_1.default).userId;
    var bookmarks = (0, react_1.useContext)(BookmarkedContext_1.default).bookmarks;
    var _a = (0, react_1.useState)('bookmarked'), tab = _a[0], setTab = _a[1];
    var _b = (0, react_1.useState)(1), currentPage = _b[0], setCurrentPage = _b[1];
    var _c = (0, react_query_1.useQuery)(['bookmarked-vacancies', { page: currentPage }], function () { return axios_1.default.post('/data/bookmarked-vacancies', { vacancyIds: bookmarks, page: currentPage }).then(function (result) { return result.data; }); }, { enabled: !!(bookmarks === null || bookmarks === void 0 ? void 0 : bookmarks.size) && !!userId && tab === 'bookmarked' }), userVacancies = _c.data, reFetchBoomarkedForUser = _c.refetch;
    var _d = (0, react_query_1.useQuery)(['bookmarked-vacancies-local', { page: currentPage }], function () { return axios_1.default.post('/data/bookmarked-vacancies/local', { vacancyIds: bookmarks, page: currentPage }).then(function (result) { return result.data; }); }, { enabled: !!(bookmarks === null || bookmarks === void 0 ? void 0 : bookmarks.size) && !userId && tab === 'bookmarked' }), localVacancies = _d.data, refetchLocalBookmarks = _d.refetch;
    var suggestedVacancies = (0, react_query_1.useQuery)(['suggested-vacancies', { page: currentPage }], function () { return axios_1.default.post('/data/suggested-vacancies', { page: currentPage }).then(function (result) { return result.data; }); }, { enabled: !!userId && tab === 'suggested' }).data;
    var handleTabChange = function (tabValue) {
        setTab(tabValue);
        setCurrentPage(1);
    };
    var vacancies = (0, react_1.useMemo)(function () {
        if (userId) {
            return userVacancies;
        }
        return localVacancies;
    }, [userVacancies, localVacancies, userId]);
    (0, react_1.useEffect)(function () {
        var _a;
        if ((bookmarks === null || bookmarks === void 0 ? void 0 : bookmarks.size) && bookmarks.size === ((_a = vacancies === null || vacancies === void 0 ? void 0 : vacancies.data) === null || _a === void 0 ? void 0 : _a.length)) {
            return;
        }
        if (userId && tab === 'bookmarked') {
            reFetchBoomarkedForUser();
        }
        else {
            refetchLocalBookmarks();
        }
    }, [bookmarks]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SearchBarContainer_1.default, {}), userId && ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ display: vacancyParam && isSmallScreen ? 'none' : 'flex', container: true, spacing: 5, justifyContent: "center", sx: { backgroundColor: '#e5e5e5' } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 12, md: 10, sx: { marginTop: { xs: 2, md: 0 } } }, { children: [!isSmallScreen && ((0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ color: "primary.dark", fontWeight: "bold", variant: "h3" }, { children: trans_1.default.get('labels.frontend.general.saved_vacancies') }))), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: classes.buttonGroup }, { children: [(0, jsx_runtime_1.jsx)(material_1.Button, __assign({ sx: tab === 'bookmarked' ? classes.buttonActive : classes.button, onClick: function () { return handleTabChange('bookmarked'); } }, { children: trans_1.default.get('entities.saved') })), (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ sx: tab === 'suggested' ? classes.buttonActive : classes.button, onClick: function () { return handleTabChange('suggested'); } }, { children: trans_1.default.get('navs.frontend.vacancy.suggested') }))] }))] })), !isSmallScreen && ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, md: 10 }, { children: (0, jsx_runtime_1.jsx)(Line_1.default, {}) })))] }))), tab === 'bookmarked' ? ((0, jsx_runtime_1.jsx)(VacanciesPage_1.default, { vacancies: vacancies, onPageChange: setCurrentPage })) : ((0, jsx_runtime_1.jsx)(VacanciesPage_1.default, { vacancies: suggestedVacancies, onPageChange: setCurrentPage }))] }));
};
exports.default = YourVacanciesPageContainer;
